import { onAuthStateChanged, signOut } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { auth } from "../firebase";
import { userSignOut } from "./myFunctions";

const AuthDetails = () => {
  const [authUser, setAuthUser] = useState(null);
  const [showAuthDetails, setShowAuthDetails] = useState(true); // new state variable

  useEffect(() => {
    const listen = onAuthStateChanged(auth, (user) => {
      if (user) {
        setAuthUser(user);
      } else {
        setAuthUser(null);
      }
    });

    return () => {
      listen();
    };
  }, []);


  return (
    showAuthDetails && (
      <div className="fixed right-0 w-64 bg-white rounded-lg p-4 shadow-2xl">
        {authUser ? (
          <>
            <p className="text-lg font-medium text-purple-700">{`Signed In as ${authUser.email}`}</p>
            <button className="mt-4 text-sm font-medium bg-purple-600 text-white rounded-md py-2 px-4 hover:bg-purple-500" onClick={userSignOut}>
              Sign Out
            </button>
            <button className="mt-4 text-sm font-medium bg-purple-600 text-white rounded-md py-2 px-4 hover:bg-purple-500" onClick={()=> setShowAuthDetails(false)}> 
              exit
            </button>
          </>
        ) : (
          <p className="text-lg font-medium text-purple-700">Signed Out</p>
          )}
        </div>
      )
    );
  };
  
  export default AuthDetails;
  
